export const getDesignOptionsClasses = (designOptions) => {
    let designOptionsArray = [''];
    if (designOptions?.bordered) {
        designOptionsArray.push('bordered');
    }
    if (designOptions?.dark) {
        designOptionsArray.push('dark-mode');
    }
    if (designOptions?.color) {
        designOptionsArray.push('custom-color');
    }
    return designOptionsArray.join(" ");
};
